"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalPromotionHandler = void 0;
const APIEventSystem_1 = require("../../../interfaces/APIEventSystem");
const APIBetType_1 = require("../../../interfaces/APIBetType");
class ExternalPromotionHandler {
    constructor(promoHandler, api) {
        this.injectExternalFreeBetCallback = (betData) => {
            if (betData.type === APIBetType_1.APIBetType.FREE_BET && this.activePromotion) {
                betData.type = APIBetType_1.APIBetType.NORMAL_BET;
                betData.replayAndFeatureBuy = true; //Sort of a hack, this parameter is checked in balance.js. If true, it will skip balance - bet check. And allow "normal" bets to be done without checking that you can afford to make the bet.
            }
            return betData;
        };
        this._promoHandler = promoHandler;
        this._api = api;
        api.events.on(APIEventSystem_1.APIEvent.EXTERNAL_FREE_ROUNDS, (data) => {
            var _a;
            let wasInitData = false;
            let updateWin = false;
            if (this.activePromotion == undefined) {
                if (data.bet == undefined || data.rounds == undefined) {
                    return;
                }
                this.activePromotion = {
                    amount: "" + data.bet,
                    count: data.rounds || 0,
                    messages: {},
                    promoName: "",
                    dates: { START_DATE: "", END_DATE: "", EVICT_DATE: "" },
                    rounds: data.rounds || 0,
                    used: 0,
                    winnings: ""
                };
                wasInitData = true;
            }
            if (data.rounds) {
                this.activePromotion.count = data.rounds;
            }
            if (data.bet) {
                this.activePromotion.amount = "" + data.bet;
            }
            if (data.winnings) {
                this.activePromotion.winnings = "" + data.winnings;
                updateWin = true;
            }
            if (wasInitData) {
                api.betHandler.addBetDataInjectCallback(this.injectExternalFreeBetCallback);
                if (this._betLevelBeforeEvoFreeBets == undefined) {
                    this._betLevelBeforeEvoFreeBets = api.betLevel.getLevel();
                }
                if ((_a = api.promoPanel) === null || _a === void 0 ? void 0 : _a.isActionSpinRound) {
                    api.events.trigger(APIEventSystem_1.APIEvent.STOP_AUTOPLAY);
                }
                api.slotStates.stateIsReady().then(value => {
                    var _a;
                    (_a = api.promoPanel) === null || _a === void 0 ? void 0 : _a.close();
                    promoHandler.events.trigger(promoHandler.FREE_BETS_START);
                });
            }
            else if (updateWin) {
                this._api.events.trigger(APIEventSystem_1.APIEvent.GUI_REFRESH);
            }
        });
        api.events.on(APIEventSystem_1.APIEvent.EXTERNAL_FREE_ROUNDS_ENDED, () => {
            api.betHandler.removeBetDataInjectCallback(this.injectExternalFreeBetCallback);
            this.activePromotion = undefined;
            if (this._betLevelBeforeEvoFreeBets != undefined) {
                api.betLevel.setLevel(this._betLevelBeforeEvoFreeBets);
                this._betLevelBeforeEvoFreeBets = undefined;
            }
            promoHandler.events.trigger(promoHandler.FREE_BETS_END);
        });
    }
    hasExternalPromo() {
        return this.activePromotion != undefined;
    }
    onBet(data) {
        if (data.type === APIBetType_1.APIBetType.NORMAL_BET) {
            if (this.activePromotion) {
                this.activePromotion.count = Math.max(this.activePromotion.count - 1, 0);
                this._promoHandler.events.trigger(this._promoHandler.FREE_BETS_UPDATE);
            }
        }
    }
    onSoftReset() {
        if (this.activePromotion) {
            this.activePromotion.count = Math.max(this.activePromotion.rounds - this.activePromotion.used, 0);
            this._promoHandler.events.trigger(this._promoHandler.FREE_BETS_UPDATE);
        }
    }
    getCurrentWinnings() {
        if (this.activePromotion) {
            return parseFloat(this.activePromotion.winnings) > 0 ? parseFloat(this.activePromotion.winnings) : undefined;
        }
        return undefined;
    }
    getBetHeader() {
        let text = this._api.translations.translate("BET");
        if (this.activePromotion) {
            let count = this.activePromotion.count;
            const header = count === 1 ? 'FREE BET' : 'FREE BETS';
            const translated = this._api.translations.translate(header);
            text = count + " " + translated;
        }
        return text;
    }
    getBet() {
        if (this.activePromotion) {
            return this._api.currency.formatValue(this.activePromotion.amount);
        }
        return this._api.currency.formatValue(0);
    }
    getRemainingRounds() {
        if (this.activePromotion) {
            return this.activePromotion.count;
        }
        return 0;
    }
}
exports.ExternalPromotionHandler = ExternalPromotionHandler;
//# sourceMappingURL=ExternalPromotionHandler.js.map